<template>
  <div
    class="bg-black-transparent absolute w-full h-full backdrop-filter backdrop-blur-sm top-0 left-0 flex items-center justify-center">
    <div v-if="!isGenerateLinkVisible"
         class="popup h-auto 1.5xl:w-7/10 1.8xl:w-6/10 fhd:w-5/10 p-4 mx-auto bg-white items-center classen__rounded relative">
      <div class="flex flex-col mb-7">
        <button class="self-end pr-5" @click="$emit('cancel')"><i class="fas fa-times text-3xl"></i>
        </button>
      </div>
      <div class="flex flex-col">
        <div class="w-7/10 self-center">
          <p>{{ getTranslation('currentSelection') }}: {{ selection.name }}</p>
          <textarea class="memo mt-6" maxlength="1000" v-model="memo"
                    placeholder="Add a memo here"></textarea>
          <p class="pt-5 pb-2 font-extrabold">{{ getTranslation('information') }}:</p>
          <div class="flex pb-2" @click="selectAllOptions()">
            <c-checkbox :selected="selectAll" :mode="'medium'"/>
            <label>{{ getTranslation('selectAll') }}</label>
          </div>
          <div class="grid grid-rows-11 grid-flow-col gap-4 ml-2">
            <div class="flex"
                 v-for="information in informationOptions"
                 @click="selectOption(information)">
              <c-checkbox :selected="information.selected"/>
              <label :class="{'requiredOption':information.disabled}">{{
                  information.value
                }}</label>
            </div>
          </div>
          <div class="flex flex-col">
            <button @click="generateLink"
                    class="classen__button leading-none hover__button addButtonSendInvite mb-5 px-3 self-center generateExcelButton px-5 mt-12 self-center">
              <p>{{ getTranslation('generateLink') }}</p>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isGenerateLinkVisible"
         class="bg-white classen__rounded w-9/10 1.5xl:w-4/10 h-auto px-5 py-5 pb-10">
      <div class="w-full text-right">
        <div @click="$emit('cancel')" class="cursor-pointer text-gray-50 text-3xl"><i
          class="fas fa-times"></i></div>
      </div>
      <div v-if="state === 0">
        <c-loader :inline="true"/>
        <p class="text-center title text-2xl py-5 ">{{ getTranslation('generatingLink') }}</p>
      </div>
      <div v-if="state === 1" class="flex items-center flex-col">
        <p class="text-center title text-2xl mb-10 ">{{
            getTranslation('generatingLinkSuccess')
          }}</p>
        <p class="mb-5">{{ getTranslation('currentSelection') }}: {{ selection.name }}</p>
        <div class="classen__rounded_full bg-classen__secondary w-9/10 flex">
          <div class="linkText overflow-hidden overflow-ellipsis">
            <a :href="fullLink" target="_blank">{{ fullLink }}</a>
          </div>
          <div @click="copyToClipboard(fullLink)"
               class="copyIcon bg-classen__primary cursor-pointer flex items-center justify-center text-white ">
            <img src="../../../assets/icons/copy.svg" alt="copy" class="h-6/10">
          </div>
        </div>
      </div>
      <div v-if="state === 2">
        <p class="text-center title text-2xl py-5 ">{{ getTranslation('generatingLinkFailed') }}</p>
      </div>
    </div>
    <c-loader v-if="isLoaderVisible"/>
  </div>
</template>

<script>
import getTranslation from "../../../mixins/getTranslation";
import CustomCheckbox from "../../form/CustomCheckbox";
import Loader from "../../Loader";
import GenerateLink from "./GenerateLink";
import copyToClipboard from "../../../mixins/copyToClipboard";
import Input from "../../form/Input";

export default {
  name: "GenerateLinkInformation",

  mixins: [getTranslation, copyToClipboard],

  props: {
    selection: {required: true, default: ''}
  },

  components: {
    Input,
    'c-checkbox': CustomCheckbox,
    'c-loader': Loader,
    'c-generate-link-popup': GenerateLink,
  },

  data() {
    return {
      isLoaderVisible: true,
      isGenerateLinkVisible: false,
      selectAll: false,
      informationOptions: [],
      state: 1,
      baseUrl: '',
      link: 'test',
      memo: '',
    }
  },

  created() {
    this.setInformationOptions();
    this.baseUrl = process.env.VUE_APP_URL;
  },

  computed: {
    fullLink() {
      return `${this.baseUrl}/#/selection/${this.link}`
    }
  },

  methods: {
    selectAllOptions() {
      this.selectAll = !this.selectAll;
      this.informationOptions.forEach((option) => {
        if (option.disabled) {
          return;
        }
        option.selected = this.selectAll;
      });
    },

    selectOption(information) {
      if (!information.disabled) {
        this.$set(information, 'selected', !information.selected);
      }
      this.selectAll = !this.informationOptions.some((option) => option.selected === false);
    },

    setInformationOptions() {
      this.informationOptions = [
        {
          key: 'articleNumber',
          value: this.getTranslation('articleNumber'),
          selected: true,
          disabled: true
        },
        {
          key: 'articleName',
          value: this.getTranslation('articleName'),
          selected: true,
          disabled: true
        },
        {key: 'range', value: this.getTranslation('range'), selected: false},
        {key: 'category', value: this.getTranslation('category'), selected: false},
        {key: 'branding', value: this.getTranslation('collection'), selected: false},
        {key: 'productgroup', value: this.getTranslation('productGroup'), selected: false},
        {key: 'dimensions', value: this.getTranslation('dimensions'), selected: false},
        {key: 'structure', value: this.getTranslation('structure'), selected: false},
        {key: 'lockingSystem', value: this.getTranslation('lockingSystem'), selected: false},
        {key: 'bevel', value: this.getTranslation('bevel'), selected: false},
        {key: 'bevelColor', value: this.getTranslation('bevelColor'), selected: false},
        {key: 'acClassification', value: this.getTranslation('acClassification'), selected: false},
        {key: 'wearclass', value: this.getTranslation('wearClass'), selected: false},
        {key: 'decorName', value: this.getTranslation('decor'), selected: false},
        {key: 'decorColor', value: this.getTranslation('decorColor'), selected: false},
        {key: 'decorMaterial', value: this.getTranslation('decorMaterial'), selected: false},
        {key: 'planksPerBox', value: this.getTranslation('planksPerBox'), selected: false},
        {key: 'sqmPerUnit', value: this.getTranslation('areaPerBox'), selected: false},
        {key: 'weightPerBox', value: this.getTranslation('weightPerBox'), selected: false},
        {key: 'boxesPerPallet', value: this.getTranslation('boxesPerPallet'), selected: false},
        {key: 'sqmPerPallet', value: this.getTranslation('areaPerPallet'), selected: false},
        {key: 'weightPerPallet', value: this.getTranslation('weightPerPallet'), selected: false},
        {key: 'grossWeightOfSqm', value: this.getTranslation('grossWeightOfSqm'), selected: false},
        {key: 'eanCode', value: this.getTranslation('eanCode'), selected: false},
      ]

      this.isLoaderVisible = false;
    },

    generateLink() {
      this.isGenerateLinkVisible = true;
      const info = this.informationOptions.filter((info) => info.selected === true).map((info) => info.key);

      this.$dashboardStore.dispatch('generateLink', {
        selectionId: this.selection.id,
        selectedInformation: info,
        memo: this.memo,
      })
        .then((res) => {
          this.state = 1;
          this.link = res.id
        })
        .catch(() => {
          this.state = 3;
        });
    }
  }
}
</script>

<style scoped>
.generateExcelButton {
  height: 42px;
}

.copyIcon {
  width: 65px;
  border-radius: 0 25px 25px 0;
}

.linkText {
  width: calc(100% - 65px);
}

.requiredOption:after {
  content: ' *';
  color: #E92323;
}

.memo {
  height: 100px;
  width: 100%;
  padding: 10px;
  background-color: #EAEBEC;
  resize: none;
}
</style>
